

var api = 'https://api.questtomio.com/index.php?r=';

if(window.location.hostname.indexOf('questtomio.com') != -1){
    api = 'https://api.questtomio.com/index.php?r='
}

export default {
    apiHost: api
    // apiHost: 'http://localhost:3000'
}



// WEBPACK FOOTER //
// ./src/config.js